// templates
require('./app/templates/sign_in.html')
var requireTemplates = require.context('./app/templates', true, /\.html$/)
requireTemplates.keys().forEach(requireTemplates)

// images
// var requireThumbs = require.context('./resources/img', true, /\.(jpg|png)$/);
// requireThumbs.keys().forEach(requireThumbs);
require('./resources/img/person.svg')
require('./resources/img/title-header.svg')
require('./resources/img/shimimaru.png')
require('./resources/img/comp_stamp.png')
require('./resources/img/diamond.png')
require('./resources/img/diamond_inactive.png')
require('./resources/img/pencil.png')
require('./resources/img/quake.png')
require('./resources/img/download_ios.png')
require('./resources/img/download_android.png')
require('./resources/img/chrome.png')
require('./resources/img/firefox.png')
// requireThumbs = require.context('./resources/img/shimimaru', true, /\.(jpg|png)$/);
// requireThumbs.keys().forEach(requireThumbs);

// firebase init
require('./app/firebase-init.js')

// js
//require('./app/diable_console.js')
require('./bower_components/angular-socialshare/dist/angular-socialshare.min.js')
require('./bower_components/ng-file-upload/ng-file-upload.js')
require('./bower_components/firebase-util/dist/firebase-util.js')
require('./bower_components/jsdiff/diff.js')
require('./bower_components/angular-timeline/dist/angular-timeline.js')
require('./bower_components/angular-timeline/dist/angular-timeline.css')
require('./bower_components/angulartics/dist/angulartics.min.js')
require('./bower_components/angulartics-google-analytics/dist/angulartics-ga.min.js')
require('./bower_components/annotorious/annotorious.min.js')

require('./bower_components/angular-cookies/angular-cookies.min.js')
require('./bower_components/angular-translate/angular-translate.min.js')
require('./bower_components/angular-translate-storage-cookie/angular-translate-storage-cookie.min.js')
require('./bower_components/angular-translate-storage-local/angular-translate-storage-local.min.js')
require('./bower_components/angular-translate-loader-static-files/angular-translate-loader-static-files.min.js')

require('!css-loader!resolve-url-loader!./bower_components/annotorious/css/annotorious.css')
//grequire('css-loader!./bower_components/angular-timeline/dist/angular-timeline-animations.css');

require('./app/app.coffee')
controllers = require.context('./app/controllers', true, /\.coffee$/)
services = require.context('./app/services', true, /\.coffee$/)
controllers.keys().forEach(controllers)
services.keys().forEach(services)
require('./app/directives.coffee')
require('./app/filters.coffee')

// sass
require('./app/assets/app.scss')



//////////////////
// WEBPACK FOOTER
// ./entry.js
// module id = 0
// module chunks = 0